import {
    SET_SAVE_RECEIVING_BRANCH
} from "./FleetTransferReceivingBranchType"

const initialState = {
    receivingBranchValues: null
}


const reducer = (state = initialState, action: any) => {
    if (action.type === SET_SAVE_RECEIVING_BRANCH) {
        return {
            ...state,
            receivingBranchValues: action.receivingBranchValues,
        };
    }
    else {
        return state;
    }
};

export default reducer;